import { render, staticRenderFns } from "./ManageArea.vue?vue&type=template&id=adba56ce"
import script from "./ManageArea.vue?vue&type=script&lang=js"
export * from "./ManageArea.vue?vue&type=script&lang=js"
import style0 from "./ManageArea.vue?vue&type=style&index=0&id=adba56ce&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports